/**
 * EvaluateFormulaElements — the `.lookup-element-with-formula` pass
 * (REQ-FORM-8; research/04 §2.7): parse+eval `data-formula`, clamp
 * Math.max(data-minvalue, v), write via setAttribute("value", …). Runs
 * before the main parse (called first inside UpdatePrice's try).
 *
 * The eval itself lives in formula/evaluate.ts (the single eval boundary);
 * evaluateFormulaElementFormula re-declares this callback's v1 locals so
 * direct-eval identifier capture is unchanged (ERRATA #10).
 */
import { FormulaParser, evaluateFormulaElementFormula } from "../formula";
import $ from "jquery";

export function EvaluateFormulaElements(): void {
  $(".lookup-element-with-formula").each((d: any, elem: any) => {
    //console.log('lookup-element-',elem);
    let elem_formula = $(elem).data("formula");
    let elem_formula_minvalue = $(elem).data("minvalue");
    let parsedFormula = FormulaParser(elem_formula.toString());
    let evaluatedValue = evaluateFormulaElementFormula(
      parsedFormula as any,
      d,
      elem,
      elem_formula,
      elem_formula_minvalue,
    );
    let elem_finalValue = Math.max(elem_formula_minvalue, evaluatedValue);
    //console.log('formula 2', elem_finalValue)
    elem.setAttribute("value", elem_finalValue);
  });
}
